import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, message, Form, Select } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import { use } from "echarts";
import { EditOutlined } from "@ant-design/icons";
import { AppTable } from "../common";

interface Contentdata {
  full_name?: string;
  email: number;
  package_name: string;
  request_type: string;
  company: {
    name: string;
  };
  user: {
    full_name: string;
    email: string;
  };
  _id: string;
  reference_id: string;
  isComplete: boolean;
}

interface DataTableProps {
  contentData: Contentdata[];
}
function AddOnsChangeTable({ contentData }: DataTableProps) {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    console.log(contentData, "contentData 123");
  }, [contentData]);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "Reference ID",
      dataIndex: "reference_id",
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      render: (record) => <div className="truncate">{record}</div>,
      onFilter: (value, record) => {
        return (
          String(record?.company)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.package_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.full_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.reference_id)
            .toLowerCase()
            .includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Business Name",
      dataIndex: "company",
      key: "company",
      render: (record) => <div className="truncate">{record}</div>,
      // sorter: (a: any, b: any) => a._id.localeCompare(b.company),
      ellipsis: true,
    },
    {
      title: "Name",
      dataIndex: "full_name",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space style={{ margin: "0 auto" }}>
          <Button
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
            // onClick={() =>
            //   addPaymentDetails(
            //     record?.email,
            //     record?.package_name,
            //     record?.request_type
            //   )
            // }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="dataTable">
        <div className="filterMenu">
          <div></div>
          <Input.Search
            onSearch={(value) => {
              setSearchText(value.toLowerCase());
            }}
            onChange={(e) => {
              setSearchText(e.target.value.toLowerCase());
            }}
            className="searchField"
            placeholder="Search here..."
          />
        </div>
        <AppTable
          className="dataGrid"
          columns={columns}
          dataSource={contentData}
        />
      </div>
    </>
  );
}

export default AddOnsChangeTable;
